module.exports = __webpack_public_path__ + "static/ApercuMonoProBold-95cbfc9ae5b8fecbc9c867613d58510f.ttf";